export enum CalendarItemType {
  Event = 'event',
  Reservation = 'reservation',
}
